module.exports = __webpack_public_path__ + "img/cover-casino-bg.b2ba020b.jpg";